
<script>
  import { onMount, createEventDispatcher } from "svelte";
  import Field from "../FormField.svelte";
  import DOB from "../HTMLElements/DOB.svelte";
  import TextBox from "../HTMLElements/TextBox.svelte";
  import Radio from "../HTMLElements/RadioInput.svelte";
  import AddressPicker from "../HTMLElements/AddressPicker.svelte";
  import Select from "../HTMLElements/Select.svelte";
  import {  HelpSummary, ChildChunks } from "./store.js";
  import { GetChild } from "./service.js";
  import * as objectWrapper from "../Utils/ObjectWrapper.js";
  import Modal from "../HTMLElements/Modal.svelte";
  let differentAddressHelpId = "NotAtSameAddress";
  export let showDifferentAddressModal = false;
  import * as Validator from "../Utils/ValidateFormFields.js";
  import Help from "../help.svelte";
  import wrappedFetch from '../../wrappedfetch.js';
  import Login from "../account/login.svelte";

  const dispatch = new createEventDispatcher();
  export let sibling;
  export let schoolId;
  export let allowDisable =true

  let hasApplication = sibling.hasApplication=='Y';
  let ref = null;
  let wrappedObj;
  let dateofbirth;
  let isValidDOB;
  let isValidDate = undefined;
  let bindParams = {
    isRequired: true,
    dateFrom: new Date("2011/01/31"),
    dateTo: new Date("2021/01/31"),
    allowDisable: allowDisable || hasApplication
  };

  let isFormValid = true;
  let isDirty =false;
  export let error = "";
  let availableSchools= [];
  let item = [
    { value: "Boy", TextValue: "Boy", disable:hasApplication || allowDisable },
    { value: "Girl", TextValue: "Girl",disable:hasApplication || allowDisable  }
  ];
  let postcodeDirty = false;
  let username = "sibblingdetails";

  export let radioParams = { item: item, required: true };  
  
  $: {
    if(wrappedObj && wrappedObj.useParentAddress.value )
      wrappedObj.address.isValid = true;     
  }

  export const saveAndExit = async () => {
    validateAndSave();
    if (isFormValid && !showDifferentAddressModal)
      dispatch("pageChange", `/user/home`);
  }

  const getSiblingSchools = ()=>{ 
     availableSchools =[];
    isDirty=false;
     if (wrappedObj.dob.value && wrappedObj.dob.isValid && wrappedObj.gender.value)
      return wrappedFetch(`/child/GetLinkedSchools?schoolId=${schoolId}&dob=${wrappedObj.dobStr.value}&gender=${wrappedObj.gender.value}`)
      .then(response => response.json())
      .then(response => {       
        isDirty = true;
        availableSchools = response;        
        if( availableSchools.length == 0){
          wrappedObj.currentSchoolId.value = '';
          wrappedObj.currentSchoolId.isValid = false;
        }
        else if (availableSchools.length == 1 && wrappedObj.currentSchoolId.value == '') 
          wrappedObj.currentSchoolId.value = availableSchools[0].id;
        else{
          wrappedObj.currentSchoolId.value = sibling.currentSchoolId;
        }
      });
      else{
    availableSchools =[];
    wrappedObj.currentSchoolId.value = '';
    wrappedObj.currentSchoolId.isValid = false;
      }
  }

  ChildChunks.set({
      details: {
        id: sibling.id,
        parentId: sibling.parentId,
        forename: sibling.forename,
        middleName: sibling.middleName,
        surname: sibling.surname,
        dob: sibling.dob,
        gender: sibling.gender ? (sibling.gender == "M" ? "Boy" : "Girl") : null,
        useParentAddress:sibling.useParentAddress, 
        addressId: sibling.addressId,
        councilTaxRef: sibling.councilTaxRef,
        address: sibling.address,
        parentAddress: sibling.parentAddress,
        currentSchoolId: sibling.currentSchoolId,
        dobStr:sibling.dobStr
      }
    });
  wrappedObj = objectWrapper.wrapObject($ChildChunks.details);
  wrappedObj.currentSchoolId = { value: "", isDirty: false, isValid: false, ref: null };  

  onMount(async () => {

    if (wrappedObj.dob.value && wrappedObj.dob.isValid && wrappedObj.gender.value)
      await getSiblingSchools();
    ref.focus();
    //if (availableSchools.length == 1) wrappedObj.currentSchoolId.value = availableSchools[0].id;
  });

  const handleModalContinue = () => {
    showDifferentAddressModal = false;
    dispatch("pageChange", `/application/relationdetails/${id}`);
  };

  const isValidSibling = async(sibling) => {
       await wrappedFetch(`/child/isvalidsibling`,{
         method: "post",
       headers: {
          'Content-Type': 'application/json'
        },
      body: JSON.stringify(sibling)
    })
      .then(response => response.json())
      .then(response => {

      });
  }

  function saveChild() {
    ChildChunks.set({ details: objectWrapper.unwrapObject(wrappedObj) });
   
    $ChildChunks.details.gender = $ChildChunks.details.gender == "Boy" ? "M" : "F";
    $ChildChunks.details.useParentAddress = wrappedObj.useParentAddress.value ? "Y" : "N";   
    $ChildChunks.details.currentSchoolId = wrappedObj.currentSchoolId.value; 
    sibling = $ChildChunks.details; 
  }

  export const validateAndSave = async () => {
    isFormValid = true;  
    showDifferentAddressModal = false;  
  postcodeDirty=true;

    if(!Validator.validate(wrappedObj) || !wrappedObj.currentSchoolId.value || (wrappedObj.currentSchoolId.value && wrappedObj.currentSchoolId.value == '')) {      
      isFormValid = false;
      error = "Please ensure that you have completed the required fields.";
      wrappedObj = wrappedObj;
      return false;
    }
 
    //don't think we should be doing this
    //if (!wrappedObj.useParentAddress.value) showDifferentAddressModal = true;

    saveChild();

    return true;
  
  };

</script>


<div class="step-1-shows">

  {#if wrappedObj}
    <Field label="First Name">
      <span slot="inputField">
        <TextBox
          placeholder="First Name"
          isRequired="true"
          bind:text={wrappedObj.forename.value}
          bind:isValid={wrappedObj.forename.isValid}
          bind:isDirty={wrappedObj.forename.isDirty}
          bind:ref
          label="the sibling's first name"
          disabled={hasApplication ||  allowDisable} />
      </span>
    </Field>

    <Field label="Middle Name" isRequired={false}>
      <span slot="inputField">
        <TextBox
          placeholder="Middle Name"
          isRequired="false"
          bind:text={wrappedObj.middleName.value}
          bind:isValid={wrappedObj.middleName.isValid}
          bind:isDirty={wrappedObj.middleName.isDirty}
          label="the sibling's middle name"
           disabled={hasApplication ||  allowDisable}  />
      </span>
    </Field>

    <Field label="Last Name">
      <span slot="inputField">
        <TextBox
          placeholder="Last Name"
          isRequired="true"
          bind:text={wrappedObj.surname.value}
          bind:isValid={wrappedObj.surname.isValid}
          bind:isDirty={wrappedObj.surname.isDirty}
          label="the sibling's last name" 
           disabled={hasApplication ||  allowDisable} />
      </span>
    </Field>

    <Field label="Date of Birth" hasIconRight={false}>
      <span slot="inputField">
        <DOB
          bind:dob={wrappedObj.dob.value}
          bind:dobStr={wrappedObj.dobStr.value}
          bind:isValid={wrappedObj.dob.isValid}
          bind:isDirty={wrappedObj.dob.isDirty}
          {...bindParams} on:changed={getSiblingSchools} 
          />
      </span>
    </Field>

    <Field label="Sex">
      <span slot="inputField">
        <Radio
          bind:group={wrappedObj.gender.value}
          bind:isDirty={wrappedObj.gender.isDirty}
          bind:isvalid={wrappedObj.gender.isValid}
          label="sex"
          errorMessage="You must select a sex. "
          {...radioParams} on:changed={getSiblingSchools} />
      </span>
    </Field>

    <Field
      info="Postcode for the child's address. A valid postcode is less than 8
      characters."
      helpId="help34"
      bind:hideInfo={wrappedObj.address.isValid}
      label="Address"
       on:showHelp={event =>{ dispatch('showHelp',event.detail)}}  isDispatch={true}>
      <span slot="inputField">
        <div class="field">
          <label class="checkbox">
            <input
              type="checkbox"
              bind:checked={wrappedObj.useParentAddress.value}  disabled={hasApplication ||  allowDisable} />
            Use your home address
          </label>
        </div>
        {#if wrappedObj.useParentAddress.value}
          {#each wrappedObj.parentAddress.value.addr.split(',') as addr}
           {addr}<br/>
          {/each}
        {:else}
          <AddressPicker
            bind:selectedAddress={wrappedObj.address.value}
            bind:isValid={wrappedObj.address.isValid}
            bind:isAddressDirty={wrappedObj.address.isDirty}
            bind:isPostcodeDirty={postcodeDirty}
            isRequired={!wrappedObj.useParentAddress.value}
            bind:username={username} />
        {/if}
      </span>
    </Field>
    <Field label="Current school">
      <span slot="inputField">

        <Select
          items ={availableSchools}
          label= "current school"
          labelText = "name"
          selectedValueText = "id"
          placeholder="Select an option"
          bind:selectedValue={wrappedObj.currentSchoolId.value}
          bind:isDirty={wrappedObj.currentSchoolId.isDirty}
          bind:isValid={wrappedObj.currentSchoolId.isValid}
          bind:this={wrappedObj.currentSchoolId.ref}
          isRequired={true}
          disabled={hasApplication ||  allowDisable }/>
      </span>       
    </Field>
   
    <hr />
 {#if availableSchools.length < 1 && isDirty}
        <div class="notification is-invalid">
       <ul class="help">
        <li>	You have added a sibling (brother or sister) with a date of birth which shows they will not be attending this school in September</li>
        <li>	Please correct the sibling’s (brother or sister) date of birth OR use the ‘Back’ button to return to the ‘Sibling information’ page and select ‘No’ to continue without adding a sibling </li>
        <li>  You may have changed the sex of the sibling (brother or sister)</li>
      </ul>
      </div>
     
     
    {/if}
    {#if !isFormValid || error != ""}
      <div class="notification is-invalid">
        <p style="margin-bottom:0px;" class="help">{@html error}</p>
      </div>
    {/if}

  {/if}
</div>


